export const INFO_SECURITY_TEXT = 'Your personal information is kept secure.';
